import moment from "moment";

export const cleanShortDescription = (htmlString) => {
  return htmlString
    ?.replace(/<h3>/gi, "<div>")
    ?.replace(/<h2>/gi, "<div>")
    ?.replace(/<\/h3>/gi, "</div>")
    ?.replace(/<\/h2>/gi, "</div>")
    ?.replace(/<strong>/gi, "")
    ?.replace(/<\/strong>/gi, "");
};

export const truncateJobDescription = (html, length = 50) => {
  if (!html) return "";
  return html.length > length ? `${html.slice(0, length)}...` : html;
};

export const formatPostedAgo = (creationTime, t) => {
  if (!creationTime) return t("Notifications.Just Now");

  const duration = moment.duration(moment().diff(moment.utc(creationTime)));
  const years = duration.years();
  const months = duration.months();
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();

  if (years > 0) {
    return `${years} ${t("Notifications.Year")}${years > 1 ? "s" : ""} ${t("Notifications.Ago")}`;
  }
  if (months > 0) {
    return `${months} ${t("Notifications.Month")}${months > 1 ? "s" : ""} ${t("Notifications.Ago")}`;
  }
  if (days > 0) {
    return `${days} ${t("Notifications.Day")}${days > 1 ? "s" : ""} ${t("Notifications.Ago")}`;
  }
  if (hours > 0) {
    return `${hours} ${t("Notifications.Hour")}${hours > 1 ? "s" : ""} ${t("Notifications.Ago")}`;
  }
  if (minutes > 0) {
    return `${minutes} ${t("Notifications.Minute")}${minutes > 1 ? "s" : ""} ${t("Notifications.Ago")}`;
  }
  return t("Notifications.Just Now");
};

export const companyProfilePath = (item) => {
  if (!item?.compUid) return null;
  return item.slug
    ? `/Company/${item.compUid}/${item.slug}`
    : `/Company/${item.compUid}`;
};
